module.exports = __webpack_public_path__ + "static/media/Sharp-LQ104V1LG81-Tech-Drawing.ea971dc1.png";